/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text[_ngcontent-%COMP%]{font-size:13px;color:#1a3349}"];
export { styles as styles };
